import { AccountDetailContainer } from "./AccountDetailContainer";

export default AccountDetailContainer;
